import { render } from "./NotificationWidget.vue?vue&type=template&id=79d0fe2a"
import script from "./NotificationWidget.vue?vue&type=script&lang=js"
export * from "./NotificationWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__